import axios from 'axios';

export const backendURL = process.env.REACT_APP_BACKEND_URL as string;

export const apiClient = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    headers: {
        'content-type': 'application/json',
    },
});
